module.exports = __webpack_public_path__ + "store/img/DYOT-banner-tag1-licensing.d39c7eb1.gif";